import { render, staticRenderFns } from "./AttributesFieldset.vue?vue&type=template&id=2111e872&"
import script from "./AttributesFieldset.vue?vue&type=script&lang=js&"
export * from "./AttributesFieldset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports